const data = [
    {name: '18-24', uv: 31.47, pv: 2400, fill: '#3367d6'},
    {name: '25-29', uv: 26.69, pv: 4567, fill: '#83a6ed'},
    {name: '30-34', uv: 15.69, pv: 1398, fill: '#8dd1e1'},
    {name: '35-39', uv: 8.22, pv: 9800, fill: '#ffc658'},
    {name: '40-49', uv: 8.63, pv: 3908, fill: '#a4de6c'},
    {name: '50+', uv: 2.63, pv: 4800, fill: '#d0ed57'},
    {name: 'unknow', uv: 6.67, pv: 4800, fill: '#ffc658'}
];
export default data;


// WEBPACK FOOTER //
// ./app/routes/charts/routes/radial/Components/data.js